import classNames from 'classnames'
import React from 'react'

import styles from './checkbox.module.scss'

interface CheckboxProps {
  isChecked: boolean
  setIsChecked: (checked: boolean) => void
  label?: string
  className?: string
  labelClassName?: string
  disabled?: boolean
  ariaLabel?: string
}

export const Checkbox = ({
  label,
  isChecked,
  setIsChecked,
  className,
  labelClassName,
  disabled = false,
  ariaLabel,
}: CheckboxProps) => {
  return (
    <label className={classNames(styles.checkboxWrapper, className)}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() => {
          if (!disabled) {
            setIsChecked(!isChecked)
          }
        }}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      {label ? <span className={labelClassName}>{label}</span> : null}
    </label>
  )
}
export default Checkbox
